export const GET_RANODM_MEAL = 'GET_RANODM_MEAL';
export const GET_RANODM_MEAL_SUCCESS = 'GET_RANODM_MEAL_SUCCESS';
export const GET_RANODM_MEAL_ERROR = 'GET_RANODM_MEAL_ERROR';